import LibbyPromoView from '../components/libby_promo_intercept/libby_promo';

$(() => {
    const el = $('.LibbyPromo');
    new LibbyPromoView({el, bus: window.globalEvents});
});
